import { createContext } from 'react'
import { FileWrapper, Step } from '../types/types'

export type FileuploadPickerContextValues = {
  files: FileWrapper[]
  maxsizeInBytes?: number
  showModal?: boolean
  accept?: string
  reject?: string
  onCloseModal?: () => void
  onSaveModal?: () => void
  step?: Step
  setStep?: (step: Step) => void
  onChange: (files: FileWrapper[]) => void
  removeFile: (file: FileWrapper) => void
  archiveListPagination: {
    page: number
    pageSize: number
  }
  setArchiveListPagination: (pagination: {
    page: number
    pageSize: number
  }) => void

  archiveSearchListPagination: {
    page: number
    pageSize: number
  }
  setArchiveSearchListPagination: (pagination: {
    page: number
    pageSize: number
  }) => void

  archiveSearchText?: string
  setArchiveSearchText?: (text: string) => void
}

export const FileuploadPickerContext =
  createContext<FileuploadPickerContextValues | null>(null)

FileuploadPickerContext.displayName = 'FileuploadPickerContext'
